import { isStringField, RichAssetDatePicker, RichAssetTimePicker, RichAssetPersistentMenu, } from '../../generated/ast.js';
import { RichAssetTypesDisplayNames } from '../../common/mappings.js';
import { FRONTEND_PROPERTY_NAME } from '../../common/constants.js';
export function validateMessage(node, nodeFields, pifFileSummary, accept) {
    const { idField, nodeTypeField, messageField, richAssetField } = nodeFields;
    // message is only for decision nodes
    if (nodeTypeField?.nodeType?.value !== 'D')
        return;
    if (messageField && isStringField(messageField.message)) {
        if (richAssetField &&
            [
                RichAssetDatePicker.$type,
                RichAssetTimePicker.$type,
                RichAssetPersistentMenu.$type,
            ].indexOf(richAssetField?.content?.$type) !== -1) {
            accept('error', `'message' should not be set when ${RichAssetTypesDisplayNames[richAssetField.content.$type]} is specified.`, {
                node: messageField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.MESSAGE,
                },
            });
        }
        const message = messageField.message.value;
        if (!message)
            return;
        // Check for inconsistent use of braces inside the message string
        // For using variable references, we should get pairs of single
        // opening/closing braces
        let lastBrace = '}';
        let hasMismatchedBraces = false;
        for (let i = 0; i < message.length; i++) {
            const char = message.charAt(i);
            if (char === '{' || char === '}') {
                if (lastBrace === char) {
                    hasMismatchedBraces = true;
                }
                lastBrace = char;
            }
        }
        if (hasMismatchedBraces || lastBrace === '{') {
            accept('error', `Inconsistent use of curly braces in the message string. Please correct or the references will not resolve.`, {
                node: messageField,
                data: {
                    id: idField?.id?.value,
                    nodeNumber: node?.name,
                    propertyName: FRONTEND_PROPERTY_NAME.MESSAGE,
                },
            });
        }
        // Check if the message string references any global variables
        const variableReferences = message.match(/\{([A-Z][A-Z0-9_]*?)\}/g);
        variableReferences?.forEach((variableReference) => {
            // strip the parantheses to get the name of the variable
            const variableName = variableReference.substring(1, variableReference.length - 1);
            // Check the pifFileSummary to verify that this global variable exists
            if (!pifFileSummary.globalVariablesMap[variableName]) {
                accept('error', `Referenced global variable '${variableName}' does not exist.`, {
                    node: messageField,
                    data: {
                        id: idField?.id?.value,
                        nodeNumber: node?.name,
                        propertyName: FRONTEND_PROPERTY_NAME.MESSAGE,
                    },
                });
            }
        });
    }
}
//# sourceMappingURL=validate-message.js.map